// sticky-atc.js — affiche le sticky ATC quand le bouton natif sort de la viewport.
// Délègue le clic vers le bouton natif pour réutiliser la logique de variante/quantité.

(function () {
  'use strict';

  const root = document.querySelector('[data-ct-sticky-atc]');
  if (!root) return;

  const watchSel = root.getAttribute('data-watch-selector') || '.product-form__buttons';
  const watched = document.querySelector(watchSel);
  const stickyBtn = root.querySelector('[data-ct-atc]');
  const stickyPrice = root.querySelector('[data-ct-price]');

  if (!watched || !stickyBtn) return;

  // Trouve le bouton ATC natif le plus proche pour déléguer le clic.
  const nativeBtn =
    watched.querySelector('button[name="add"], button[type="submit"], .product-form__submit') ||
    document.querySelector('button[name="add"], .product-form__submit');

  // IntersectionObserver : visible si le bouton natif est OFF-screen
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          // Visible quand le bouton natif n'est PAS visible
          root.classList.toggle('is-visible', !e.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -10% 0px' }
    );
    io.observe(watched);
  } else {
    // Fallback : toujours visible
    root.classList.add('is-visible');
  }

  // Délègue le clic au bouton natif pour conserver la logique form
  stickyBtn.addEventListener('click', (ev) => {
    ev.preventDefault();
    if (!nativeBtn) return;
    if (nativeBtn.disabled) return;
    nativeBtn.click();
  });

  // Sync du prix quand la variante change (Dawn dispatche `variant:change`)
  document.addEventListener('variant:change', (ev) => {
    const variant = ev?.detail?.variant;
    if (!variant) return;

    if (stickyPrice && variant.price != null) {
      // Money formatting basique en EUR — adapte si shop différent
      const price = (variant.price / 100).toFixed(2).replace('.', ',');
      stickyPrice.textContent = `${price} €`;
    }

    if (variant.available) {
      stickyBtn.disabled = false;
      stickyBtn.textContent = stickyBtn.dataset.labelDefault || stickyBtn.textContent;
    } else {
      stickyBtn.disabled = true;
      stickyBtn.textContent = stickyBtn.dataset.labelUnavailable || 'Indisponible';
    }
  });
})();
